import { useParams } from "react-router-dom";
import MeetingForm from '../components/MeetingForm';
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../store/slices/authSlice";

export const MeetingFormWrapper = () => {
    const { familyId } = useParams();
    const user = useSelector(selectCurrentUser);

    return <MeetingForm userId={user?.id} autoFamilyId={familyId || ""} />;
};
